let _ = (t)=>t, t;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from '@emotion/react';
import { BottomSheet, Box, KlarnaLogo, Stack, Text, useTheme } from 'features/fabric';
import RichTextMarkdown from 'features/richText/components/richTextMarkdown/RichTextMarkdown';
import { getCountryCode } from 'framework/utils/core/siteUtils';
import FinancingCard from './components/FinancingCard';
import InstallmentsList from './components/InstallmentsList';
import styles from './InstallmentsModal.scss';
import { useInstallmentsModalTranslations } from './useInstallmentsModalTranslations';
export const getPaymentOption = (termLength)=>{
    return termLength <= 4 ? 'PAY_IN_X' : 'FINANCING';
};
const InstallmentsModal = ({ open, onCtaClick, onClose, installment })=>{
    const { modalTitle, mainDescription, disclaimer, goToProductPage, getWhatYouLove, learnMore } = useInstallmentsModalTranslations(installment.termLength);
    const paymentOption = getPaymentOption(installment.termLength);
    const isUkMarket = getCountryCode() === 'UK';
    return /*#__PURE__*/ _jsxs(BottomSheet, {
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ _jsx(BottomSheet.Header, {
                className: isUkMarket ? styles.header : '',
                left: isUkMarket ? /*#__PURE__*/ _jsx(Box, {
                    paddingLeft: {
                        base: 'xs',
                        l: 'sm'
                    },
                    paddingTop: "xs",
                    children: /*#__PURE__*/ _jsx(KlarnaLogo, {
                        height: 40,
                        width: 80
                    })
                }) : undefined,
                style: isUkMarket ? {
                    justifyContent: 'space-between'
                } : undefined,
                title: modalTitle
            }),
            /*#__PURE__*/ _jsx(BottomSheet.Body, {
                children: /*#__PURE__*/ _jsxs(Stack, {
                    rowGap: "l",
                    children: [
                        /*#__PURE__*/ _jsxs(Stack, {
                            gap: "none",
                            rowGap: "s",
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    color: "text-primary",
                                    size: "xl",
                                    weight: "bold",
                                    children: mainDescription
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    color: "text-secondary",
                                    size: "l",
                                    children: getWhatYouLove
                                })
                            ]
                        }),
                        paymentOption === 'FINANCING' ? /*#__PURE__*/ _jsx(FinancingCard, {
                            installment: installment
                        }) : /*#__PURE__*/ _jsx(InstallmentsList, {
                            installment: installment
                        }),
                        /*#__PURE__*/ _jsx(Stack, {
                            rowGap: "s",
                            children: /*#__PURE__*/ _jsx(Text, {
                                as: RichTextMarkdown,
                                color: "text-secondary",
                                size: "m",
                                children: learnMore
                            })
                        }),
                        /*#__PURE__*/ _jsx(Disclaimer, {
                            children: disclaimer
                        })
                    ]
                })
            }),
            onCtaClick && /*#__PURE__*/ _jsx(BottomSheet.ConfirmFooter, {
                removeCancel: true,
                confirmText: goToProductPage,
                onConfirm: onCtaClick
            })
        ]
    });
};
const Disclaimer = ({ children })=>{
    const theme = useTheme();
    return /*#__PURE__*/ _jsx(RichTextMarkdown, {
        sx: css(t || (t = _`
        max-width: 100%;

        p,
        p > *,
        a {
          font-size: ${0};
          line-height: ${0};
          color: ${0};
        }
        a:hover {
          color: ${0};
        }
      `), theme.textSize.xs, theme.textLineHeight.xs, theme.color.textTertiary, theme.color.textTertiary),
        children: children
    });
};
export default InstallmentsModal;
